import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';

@Component({
  selector: 'xray-modal',
  templateUrl: './xray-modal.component.html',
  styleUrls: ['./xray-modal.component.scss'],
})
export class XrayModalComponent {
  studyFileIds: number[] = [];
  isEditable: boolean = false;
  additionalFiles: StudyFile[] = [];
  mediaCategories: MediaCategory[] = [];
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
  }
}
